import BaseBoard from "components/common/BaseBoard";

const CorporativeCultureBaseboard = () => {
    return (
        <BaseBoard
            title={"Você também pensa assim? Imagina o que podemos fazer juntos."}
            description={"Venha trabalhar com a gente."}
            onClick={() =>
                window.open(
                    "https://csh.gupy.io/",
                    "_blank"
                )
            }
            button={"Ver vagas"}
        />
    );
}

export default CorporativeCultureBaseboard;